function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import PropTypes from 'prop-types';
import React from 'react';
import withMatchMediaProps from '@hocs/with-match-media-props';

var NarrowTable = function NarrowTable(_ref) {
  var rows = _ref.rows,
      headers = _ref.headers;

  var bodyRows = rows && rows.map(function (row, index) {
    return React.createElement(
      'table',
      { key: index, className: 'csp-data-table' },
      React.createElement(
        'tbody',
        null,
        row && row.map(function (field, fieldIndex) {
          return React.createElement(
            'tr',
            { key: fieldIndex },
            React.createElement(
              'th',
              null,
              headers[fieldIndex]
            ),
            React.createElement(
              'td',
              null,
              field
            )
          );
        })
      )
    );
  });

  return React.createElement(
    'div',
    null,
    bodyRows
  );
};

NarrowTable.propTypes = process.env.NODE_ENV !== "production" ? {
  rows: PropTypes.array,
  headers: PropTypes.array
} : {};

var WideTable = function WideTable(_ref2) {
  var rows = _ref2.rows,
      headers = _ref2.headers;

  var headerRow = headers && headers.map(function (header, index) {
    return React.createElement(
      'th',
      { key: index },
      header
    );
  });

  var bodyRows = rows && rows.map(function (row, index) {
    return React.createElement(
      'tr',
      { key: index },
      row && row.map(function (field, fieldIndex) {
        return React.createElement(
          'td',
          { key: fieldIndex },
          field
        );
      })
    );
  });

  return React.createElement(
    'table',
    { className: 'csp-data-table' },
    React.createElement(
      'thead',
      null,
      React.createElement(
        'tr',
        null,
        headerRow
      )
    ),
    React.createElement(
      'tbody',
      null,
      bodyRows
    )
  );
};

WideTable.propTypes = process.env.NODE_ENV !== "production" ? {
  rows: PropTypes.array,
  headers: PropTypes.array
} : {};

var DataTable = function (_React$Component) {
  _inherits(DataTable, _React$Component);

  function DataTable() {
    _classCallCheck(this, DataTable);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  DataTable.prototype.render = function render() {
    var _props = this.props,
        headers = _props.headers,
        rows = _props.rows,
        isNarrowScreen = _props.isNarrowScreen;

    if (!headers || !rows || headers.length < 1 || rows.length < 1) {
      return null;
    }

    if (isNarrowScreen) {
      return React.createElement(NarrowTable, { rows: rows, headers: headers });
    }

    return React.createElement(WideTable, { rows: rows, headers: headers });
  };

  return DataTable;
}(React.Component);

DataTable.propTypes = process.env.NODE_ENV !== "production" ? {
  headers: PropTypes.array,
  rows: PropTypes.array,
  isNarrowScreen: PropTypes.bool
} : {};

export default withMatchMediaProps({
  isNarrowScreen: {
    maxWidth: 719
  }
})(DataTable);


//////////////////
// WEBPACK FOOTER
// ../node_modules/@cxagroup/casper/es/components/data-table/DataTable.js
// module id = null
// module chunks = 